import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/image/fanhui.png';
const _withScopeId = n => (_pushScopeId("data-v-20e10b06"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "release"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "data:image/png;base64,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",
  alt: ""
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  key: 0,
  class: "release_msg"
};
const _hoisted_5 = {
  class: "header"
};
const _hoisted_6 = {
  class: "icon"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "fanhui",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "14px",
    "color": "#fff"
  }
}, "返回", -1));
const _hoisted_9 = [_hoisted_7, _hoisted_8];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, " 发表帖子 ", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "more"
}, null, -1));
const _hoisted_12 = {
  class: "tk-release"
};
const _hoisted_13 = {
  class: "title",
  style: {
    "padding-top": "20px"
  }
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "文章标题：自动添加期数", -1));
const _hoisted_15 = {
  key: 0,
  class: "title"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "论坛分区", -1));
const _hoisted_17 = [_hoisted_16];
const _hoisted_18 = {
  key: 1,
  class: "qishu"
};
const _hoisted_19 = {
  class: "qishu_tow"
};
const _hoisted_20 = {
  class: "qushu_nav"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "qushu_num"
};
const _hoisted_23 = {
  class: "c"
};
const _hoisted_24 = {
  key: 2,
  class: "title",
  style: {
    "padding-top": "20px"
  }
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "选杀料", -1));
const _hoisted_26 = {
  class: "code"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
  class: "textarea"
};
const _hoisted_29 = {
  key: 3,
  class: "ueditor"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "提交", -1));
const _hoisted_31 = [_hoisted_30];
import { Quill, QuillEditor } from '@vueup/vue-quill';
import { showToast } from 'vant';
import 'vant/es/toast/style';
import { article_type, article_add, last_content } from '../util/http.js';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import quillEmoji from 'quill-emoji';
import 'quill-emoji/dist/quill-emoji.css';

import { ref, toRaw, onBeforeMount, reactive } from 'vue';
// let c = (forms)=>{
//     // let url = 'https://www.389666a.com/api/upload_file'
//     let url = 'https://api.6ctkapi.com/api/upload_file'

//     let token=localStorage.getItem('Authorization');
//     axios
//         .post(url, forms, {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             Authorization: token,
//           },
//         })
//         .then((res) => {
//             let data = res.data.data[0]
//             return data
//         });
// }

export default {
  __name: 'release',
  props: {
    left: {
      default: '100',
      type: String
    },
    types: {
      default: true,
      type: Boolean
    }
  },
  emits: ['releases', 'returnUp', 'submit'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    Quill.register('modules/quillEmoji', quillEmoji);
    let acitveIndex = ref('0');
    let selectName = ref('平肖一特');
    let id = ref('');
    let title = ref('');
    let cont = ref('');
    let qishuArray = ref([{
      name: '001'
    }]);
    const uploadConfig = {
      name: 'img',
      // 必填参数 文件的参数名
      accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',
      // 可选 可上传的图片格式
      action: 'https://api.6ctkapi.com/api/upload_file',
      methods: 'POST'
      // token:localStorage.getItem('Authorization')
    };

    const toolOptions = [['bold', 'italic', 'underline', 'strike'],
    // 加粗 斜体 下划线 删除线
    // ['blockquote', 'code-block'], // 引用  代码块
    [{
      header: 1
    }, {
      header: 2
    }],
    // 1、2 级标题
    [{
      list: 'ordered'
    }, {
      list: 'bullet'
    }],
    // 有序、无序列表
    // [{ script: 'sub' }, { script: 'super' }], // 上标/下标
    [{
      indent: '-1'
    }, {
      indent: '+1'
    }],
    // 缩进
    // [{'direction': 'rtl'}],                         // 文本方向
    // [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
    [{
      header: [1, 2, 3, 4, 5, 6, false]
    }],
    // 标题
    [{
      color: ['#000000', '#ff00ff', '#c00000', '#ff0000', '#ffc000', '#92d060', '#92d060', '#00b050', '#00b0f0', '#92d060', '#0070c0', '#002060', '#7030a0']
    }, {
      background: ['#000000', '#ff00ff', '#c00000', '#ff0000', '#ffc000', '#92d060', '#92d060', '#00b050', '#00b0f0', '#92d060', '#0070c0', '#002060', '#7030a0']
    }],
    // 字体颜色、字体背景颜色
    [{
      font: []
    }],
    // 字体种类
    [{
      align: []
    }],
    // 对齐方式
    // ['clean'], // 清除文本格式
    ['image'],
    // 图片
    ['emoji'] //表情包
    // ['link', 'image', 'video'], // 链接、图片、视频
    ];

    const handlers = {
      image: function image() {
        var self = this;
        var fileInput = this.container.querySelector('input.ql-image[type=file]');
        if (fileInput === null) {
          fileInput = document.createElement('input');
          fileInput.setAttribute('type', 'file');
          // 设置图片参数名
          if (uploadConfig.name) {
            fileInput.setAttribute('name', uploadConfig.name);
          }
          // 可设置上传图片的格式
          fileInput.setAttribute('accept', uploadConfig.accept);
          fileInput.classList.add('ql-image');
          // 监听选择文件
          fileInput.addEventListener('change', function () {
            // 创建formData
            var formData = new FormData();
            formData.append(uploadConfig.name, fileInput.files[0]);
            formData.append('object', 'product');
            // 如果需要token且存在token
            if (uploadConfig.token) {
              formData.append('token', uploadConfig.token);
            }
            // 图片上传
            var xhr = new XMLHttpRequest();
            xhr.open(uploadConfig.methods, uploadConfig.action, true);
            xhr.setRequestHeader('Authorization', localStorage.getItem('Authorization'));
            // 上传数据成功，会触发
            xhr.onload = function (e) {
              if (xhr.status === 200) {
                var res = JSON.parse(xhr.responseText);
                console.log(res);
                let length = self.quill.getSelection(true).index;
                //这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。            
                self.quill.insertEmbed(length, 'image', 'https://api.6ctkapi.com/' + res.data[0]);
                self.quill.setSelection(length + 1);
              }
              fileInput.value = '';
            };
            // 开始上传数据
            xhr.upload.onloadstart = function (e) {
              fileInput.value = '';
            };
            // 当发生网络异常的时候会触发，如果上传数据的过程还未结束
            xhr.upload.onerror = function (e) {};
            // 上传数据完成（成功或者失败）时会触发
            xhr.upload.onloadend = function (e) {
              // console.log('上传结束')
            };
            xhr.send(formData);
          });
          this.container.appendChild(fileInput);
        }
        fileInput.click();
      }
    };
    let editorOption = ref({
      modules: {
        'emoji-toolbar': true,
        'emoji-shortname': true,
        toolbar: {
          container: toolOptions,
          // 工具栏选项
          handlers: handlers // 事件重写
        }
      },

      placeholder: '输入评论...' // 提示
      // theme: "snow",
    });

    const content = ref('');
    const myQuillEditor = ref();
    // 抛出更改内容，此处避免出错直接使用文档提供的getHTML方法
    const setValue = () => {
      cont.value = toRaw(myQuillEditor.value).getHTML();
    };
    // onMounted(() => {
    //   const quill = toRaw(myQuillEditor.value).getQuill()

    // })

    let returnUp = () => {
      emit('returnUp');
    };
    let releases = () => {
      emit('releases');
    };
    let Participate = ref(true);
    let qishuClick = (index, item) => {
      acitveIndex.value = index;
      selectName.value = item.name;
      id.value = item.id;
      if (item.type == 2) {
        Participate.value = false;
      } else {
        Participate.value = true;
      }
    };
    onBeforeMount(() => {
      article();
    });
    let article = () => {
      article_type().then(res => {
        selectName.value = res.data[0].name;
        id.value = res.data[0].id;
        qishuArray = res.data;
      });
    };
    let submit = () => {
      if (title.value == '') {
        showToast('标题不能为空');
      } else if (cont.value == "") {
        showToast('内容不能为空');
      } else {
        // articleAdd(title.value,cont.value,id.value)
        let data = {
          title: title.value,
          content: cont.value,
          id: id.value
        };
        emit('submit', data);
      }
    };
    let data = reactive({
      tpselect: 1,
      data: [],
      showinfo: 0,
      info: '',
      nums: [],
      balls: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪', '0尾', '1尾', '2尾', '3尾', '4尾', '5尾', '6尾', '7尾', '8尾', '9尾', '单', '双', '大', '小', '家', '野', '红', '绿', '蓝', '0头', '1头', '2头', '3头', '4头', '金', '木', '水', '火', '土'],
      balli: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    });
    //选择号码
    let select = i => {
      if (data.balli[i] == 0) {
        data.nums.push(data.balls[i]);
        content.value = data.nums.join(',');
        cont.value = data.nums.join(',');
        data.balli[i] = 1;
      }
    };
    let recordArray = ref({});
    let releaseFun = async index => {
      let res = await last_content();
      if (res == undefined) return false;
      let data = res.data;
      if (res.message == '成功') {
        showToast('加载成功！！');
        console.log(data);
        recordArray.value = data;
      } else {
        showToast(res.message);
      }
      if (index == 1) {
        content.value = recordArray.value.content;
        cont.value = recordArray.value.content;
      } else {
        title.value = recordArray.value.title;
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "release_bottom",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(releases) && _unref(releases)(...args))
      }, _hoisted_3), __props.left != 100 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: "left",
        onClick: _cache[1] || (_cache[1] = (...args) => _unref(returnUp) && _unref(returnUp)(...args))
      }, _hoisted_9)]), _hoisted_10, _hoisted_11]), _createElementVNode("div", _hoisted_12, [_createElementVNode("ul", null, [_createElementVNode("li", {
        onClick: _cache[2] || (_cache[2] = $event => _unref(releaseFun)(1))
      }, "加载上期内容"), _createElementVNode("li", {
        onClick: _cache[3] || (_cache[3] = $event => _unref(releaseFun)(2))
      }, "加载标题")])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(title) ? title.value = $event : title = $event),
        placeholder: "请输入标题"
      }, null, 512), [[_vModelText, _unref(title)]])]), __props.types ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17)) : _createCommentVNode("", true), __props.types ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qishuArray), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(_unref(acitveIndex) == index ? 'active' : ''),
          key: index,
          onClick: $event => _unref(qishuClick)(index, item)
        }, _toDisplayString(item.name), 11, _hoisted_21);
      }), 128))])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(_unref(selectName)), 1)])])) : _createCommentVNode("", true), !_unref(Participate) ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).balls, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [_createElementVNode("div", {
          class: _normalizeClass(['css' + item + ' c' + _unref(data).balli[index], "col"]),
          onClick: $event => _unref(select)(index)
        }, [_createElementVNode("div", null, _toDisplayString(item), 1)], 10, _hoisted_27)]);
      }), 128))])]), _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(data).nums.join(',')), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_unref(QuillEditor), {
        ref_key: "myQuillEditor",
        ref: myQuillEditor,
        theme: "snow",
        content: _unref(content),
        "onUpdate:content": [_cache[5] || (_cache[5] = $event => _isRef(content) ? content.value = $event : null), _cache[6] || (_cache[6] = $event => setValue())],
        options: _unref(editorOption),
        contentType: "html"
      }, null, 8, ["content", "options"])])), _createElementVNode("div", {
        class: "submit",
        onClick: _cache[7] || (_cache[7] = (...args) => _unref(submit) && _unref(submit)(...args))
      }, _hoisted_31)])) : _createCommentVNode("", true)]);
    };
  }
};